/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublicMatchOperationV2ClockConfiguration
 */
export interface PublicMatchOperationV2ClockConfiguration {
    /**
     * 
     * @type {number}
     * @memberof PublicMatchOperationV2ClockConfiguration
     */
    regularPeriodCount: number;
    /**
     * 
     * @type {number}
     * @memberof PublicMatchOperationV2ClockConfiguration
     */
    regularPeriodDurationMs: number;
    /**
     * 
     * @type {boolean}
     * @memberof PublicMatchOperationV2ClockConfiguration
     */
    overtimeEnabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof PublicMatchOperationV2ClockConfiguration
     */
    overtimePeriodCount: number;
    /**
     * 
     * @type {number}
     * @memberof PublicMatchOperationV2ClockConfiguration
     */
    overtimePeriodDurationMs: number;
}

/**
 * Check if a given object implements the PublicMatchOperationV2ClockConfiguration interface.
 */
export function instanceOfPublicMatchOperationV2ClockConfiguration(value: object): value is PublicMatchOperationV2ClockConfiguration {
    if (!('regularPeriodCount' in value) || value['regularPeriodCount'] === undefined) return false;
    if (!('regularPeriodDurationMs' in value) || value['regularPeriodDurationMs'] === undefined) return false;
    if (!('overtimeEnabled' in value) || value['overtimeEnabled'] === undefined) return false;
    if (!('overtimePeriodCount' in value) || value['overtimePeriodCount'] === undefined) return false;
    if (!('overtimePeriodDurationMs' in value) || value['overtimePeriodDurationMs'] === undefined) return false;
    return true;
}

export function PublicMatchOperationV2ClockConfigurationFromJSON(json: any): PublicMatchOperationV2ClockConfiguration {
    return PublicMatchOperationV2ClockConfigurationFromJSONTyped(json, false);
}

export function PublicMatchOperationV2ClockConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicMatchOperationV2ClockConfiguration {
    if (json == null) {
        return json;
    }
    return {
        
        'regularPeriodCount': json['regularPeriodCount'],
        'regularPeriodDurationMs': json['regularPeriodDurationMs'],
        'overtimeEnabled': json['overtimeEnabled'],
        'overtimePeriodCount': json['overtimePeriodCount'],
        'overtimePeriodDurationMs': json['overtimePeriodDurationMs'],
    };
}

export function PublicMatchOperationV2ClockConfigurationToJSON(json: any): PublicMatchOperationV2ClockConfiguration {
    return PublicMatchOperationV2ClockConfigurationToJSONTyped(json, false);
}

export function PublicMatchOperationV2ClockConfigurationToJSONTyped(value?: PublicMatchOperationV2ClockConfiguration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'regularPeriodCount': value['regularPeriodCount'],
        'regularPeriodDurationMs': value['regularPeriodDurationMs'],
        'overtimeEnabled': value['overtimeEnabled'],
        'overtimePeriodCount': value['overtimePeriodCount'],
        'overtimePeriodDurationMs': value['overtimePeriodDurationMs'],
    };
}

